import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
// Letra Figtree incluida en la app, para que se vea igual sin conexión
import '@fontsource-variable/figtree';
import './index.css';
import { NOMBRE_APP } from './config/marca';

// El título de index.html es fijo; así sigue al nombre aunque se olvide cambiarlo allí
document.title = NOMBRE_APP;

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
